



















import Vue from "vue";

export default Vue.extend({
	name: "EinladungComp",
	props: ["raid"],
	methods: {
		accept: function(): void {
			this.$emit("accept");
		},
		decline: function(): void {
			this.$emit("decline");
		},
	},
});
